"use client"

import { useMemo } from "react"
import { HttpTypes } from "@medusajs/types"
import {
  getStoredGlsDeliveryPoint,
  isGlsParcelShopOption,
} from "@/lib/util/gls-shipping"

export function useGlsShippingState(
  cart: HttpTypes.StoreCart | null | undefined,
  shippingOptions: HttpTypes.StoreCartShippingOption[],
  selectedMethodId: string
) {
  const activeOption = useMemo(() => {
    const activeId =
      selectedMethodId || cart?.shipping_methods?.at(-1)?.shipping_option_id || ""

    return shippingOptions.find((option) => option.id === activeId)
  }, [cart?.shipping_methods, selectedMethodId, shippingOptions])

  const requiresParcelPoint = isGlsParcelShopOption(activeOption)
  const selectedPoint = getStoredGlsDeliveryPoint(cart)
  const canContinue = !requiresParcelPoint || Boolean(selectedPoint)

  return {
    activeOption,
    requiresParcelPoint,
    selectedPoint,
    canContinue,
  }
}
